import React, { Component } from 'react';
import { API_ENDPOINT } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';
import deleteIcon from '../../../assets/svg/garbage.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import editIcon from '../../../assets/svg/edit.svg';
import addIcon from '../../../assets/svg/add-icon.svg';
import FormBuilder from '../../../components/forms/modalFormBuilder';
import DeleteModal from '../../../components/deleteModal';
import ErrorModal from '../../../components/errorModal';
import { between } from '../../../components/forms/validation';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';

import {
	updateParamsHelper,
	getParamsFromURL,
	parseJSON,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import Switch from '../../../components/forms/fields/switch'

class VitalLogsTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			form: false,
			preview: false,
			total: 0,
			params: {
				entries: 10,
				page: 0,
				sortField: 'tsCreatedAt',
				sortType: -1,
				filter: '',
			},
			loading: true,
			vitalLogs: [],
			error: null,
			modified: 'Not modified'.translate(this.props.lang),
			deleteVitalLog: null,
			isConsentActive: false,
			clinicUserPermissions: null
		};
	}

	get = async () => {
		this.setState({
			loading: true,
			vitalLogs: [],
			modified: 'Not modified'.translate(this.props.lang),
		});

		try {
			// fetch(API_ENDPOINT + `/users/users/patient/journal-system/has-consent/${this.props.patientId}/${this.props._groupId}`, {
			// 	method: 'GET',
			// 	headers: {
			// 		'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
			// 		'content-type': 'application/json'
			// 	},
			// }).then(res => res.json()).then((result) => {
			// 	if (result.success) {
			// 		this.setState({
			// 			isConsentActive: true
			// 		})
			// 	} else {
			// 		this.setState({
			// 			isConsentActive: false
			// 		})
			// 	}
			// })

			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/patientVitalLogs/get`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
					body: JSON.stringify({
						groupAlias: localStorage.getItem('groupAlias'),
						groupId: this.props._groupId || null,
						patientId: this.props.patientId,
						total: this.state.total,
						entries: this.state.params?.entries,
						page: this.state.params?.page,
						sortField: this.state.params?.sortField,
						sortType: this.state.params?.sortType,
						filter: this.state.params?.filter,
						isConsentGrantedAndActive: this.props.isConsentGrantedAndActive
					}),
				}
			);

			const data = await response.json();

			if (data.items) {
				const newState = {
					loading: false,
					vitalLogs: data.items,
					total: data.total,
				};

				if (data.tsModified) {
					const modified = this.props.getStringDateTs?.(
						data.tsModified,
						this.props.dateFormat
					);
					if (modified) newState.modified = modified.translate(this.props.lang);
				}

				this.setState(newState);
			} else {
				const errState = {
					loading: false,
					modified: 'Not modified'.translate(this.props.lang),
				};

				if (data.error) {
					errState.error = data.error;
				}

				this.setState(errState);
			}
		} catch (err) {
			this.setState({
				loading: false,
				error: err?.message || 'Error fetching vital logs',
			});
		}
	};

	getClinicUserData = async () => {
		try {
			const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-permission`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
				body: JSON.stringify({ groupId: this.props._groupId }),
			});

			const result = await response.json();

			this.setState({ clinicUserPermissions: result?.data?.permissions });
		} catch (err) {
			console.log('Err get clinic user data', err);
		}

	}

	componentDidMount() {
		this.getClinicUserData();

		const urlParams = getParamsFromURL();

		const newParams = {
			...this.state.params,
			entries: urlParams.entries,
			filter: urlParams.filter,
		};

		this.setState({ params: newParams }, () => {
			if (this.props.vitalLogs) {
				this.setState({
					loading: false,
					vitalLogs: this.props.vitalLogs,
				});
			} else {
				this.get();
			}
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.patientId !== this.props.patientId ||
			prevProps._groupId !== this.props._groupId ||
			prevProps.view !== this.props.view
		) {
			this.setState({
				loading: true,
				vitalLogs: [],
				modified: 'Not modified'.translate(this.props.lang),
			});

			this.get();
		}

		if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive) {
			this.get();
		}

		if (
			this.props.weight !== prevProps.weight ||
			this.props.height !== prevProps.height
		) {
			const { weight, height } = this.props;

			if (weight && height) {
				const h = height / 100;
				const bmi = +(weight / (h * h)).toFixed(2);

				this.props.changeField('bmi', bmi);
			}
		}
	}

	// always copy - paste these updateSort, updateParams, updateMultipleParams
	updateSort = (field, type) => {
		updateParamsHelper(this, { sortField: field, sortType: type });
	};

	updateParams = (name, value, restart = false) => {
		updateParamsHelper(this, { [name]: value }, restart);
	};

	updateMultipleParams = (fields, restart = false) => {
		updateParamsHelper(this, fields, restart);
	};

	insertOrUpdate = (data) => {
		const id = data._id ?? 'new';

		const hasAnyValue = [
			data.temperature,
			data.heartRate,
			data.bloodPressureSystolic,
			data.bloodPressureDiastolic,
			data.respiratoryRate,
			data.oxygenSaturation,
			data.bloodGlucose,
			data.weight,
			data.height,
			data.bmi,
			data.painScale,
			data.notes,
		].some((value) => value !== undefined && value !== null && value !== '');

		// check if there is any value
		if (!hasAnyValue) {
			this.setState({
				error: 'All fields are empty'.translate(this.props.lang),
			});
			return;
		}

		// calculate bmi and check is it valid (between 0 and 100)
		if (data.weight && data.height) {
			const heightInMeters = data.height / 100;
			data.bmi = +(data.weight / (heightInMeters * heightInMeters)).toFixed(2);
			if (data.bmi < 0 || data.bmi > 100) {
				this.setState({
					error: 'Body Mass Index(BMI) must be between 0 and 100'.translate(
						this.props.lang
					),
				});
				return;
			}
		}

		const vitalLog = {
			temperature: data.temperature,
			heartRate: data.heartRate,
			bloodPressureSystolic: data.bloodPressureSystolic,
			bloodPressureDiastolic: data.bloodPressureDiastolic,
			respiratoryRate: data.respiratoryRate,
			oxygenSaturation: data.oxygenSaturation,
			bloodGlucose: data.bloodGlucose,
			weight: data.weight,
			height: data.height,
			bmi: data.bmi,
			painScale: data.painScale,
			notes: data.notes,
		};

		const body = {
			groupId: this.props._groupId,
			patientId: this.props.patientId,
			doctorId: this.props.uData._id,
			vitalLog,
		};

		fetch(API_ENDPOINT + '/users/users/patient/patientVitalLogs/' + id, {
			method: id === 'new' ? 'POST' : 'PUT',
			headers: {
				Authorization:
					typeof localStorage !== 'undefined'
						? `Bearer ${localStorage.getItem('authToken')}`
						: null,
				'content-type': 'application/json',
			},
			body: JSON.stringify(body),
		})
			.then(parseJSON)
			.then(({ result, status }) => {
				if (result.error) {
					this.setState({ error: result.error });
				} else {
					this.get();
					this.setState({
						form: false,
					});
				}
			});
	};

	delete = (data) => {
		this.setState(
			{
				loading: true,
			},
			() => {
				fetch(
					API_ENDPOINT + '/users/users/patient/patientVitalLogs/' + data._id,
					{
						method: 'DELETE',
						headers: {
							Authorization:
								typeof localStorage !== 'undefined'
									? `Bearer ${localStorage.getItem('authToken')}`
									: null,
							'content-type': 'application/json',
						},
					}
				)
					.then(parseJSON)
					.then(({ result, status }) => {
						if (result.error) {
							this.setState({ error: result.error });
						}
						this.get();
					});
			}
		);
	};

	render() {
		let params = this.state.params;

		return (
			<>
				<div className='panel-header'>
					<h5 className='component-header'>
						{'Vital logs'.translate(this.props.lang)}
					</h5>
					<button
						className='btn add-button'
						onClick={() => {
							this.setState({
								form: true,
							});
						}}
					>
						<Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}
					</button>
				</div>

				<ListBuilder
					lang={this.props.lang}
					loading={this.state.loading}
					total={this.state.total}
					hideEntries={false}
					showNumeration={false}
					hideFilters={true}
					fields={[
						{
							type: 'text',
							label: 'Recorded info'.translate(this.props.lang),
							name: 'record'

						},
						{
							type: 'text',
							label: 'Vitals'.translate(this.props.lang),
							name: 'vatals'

						},
						{
							type: 'text',
							label: 'Cardiovascular'.translate(this.props.lang),
							name: 'cardiovasular'

						},
						{
							type: 'text',
							label: 'Physical'.translate(this.props.lang),
							name: 'bodyMeasurements'

						},
						{
							type: 'text',
							label: 'Metabolic'.translate(this.props.lang),
							name: 'metabolicData'
						},

						{
							type: 'text',
							label: 'Assessment'.translate(this.props.lang),
							name: 'painAssessment'
						},
					]}
					items={this.state.vitalLogs.map((item) => {
						return {
							...item,
							___className: item?.isDeleted ? 'journal-tab-item-delete' : '',
							record: (
								<div>
									{item.recordedBy && <div>{item.recordedBy}</div>}
									{item.recordedAt && <div>{item.recordedAt}</div>}
									{item.recordedDate && <div>{item.recordedDate}</div>}
								</div>
							),
							vatals: (
								<div>
									{item.temperature && <div><span>{'Temp.'.translate(this.props.lang)}:</span>{' '}<span style={{ fontWeight: '600' }}>{item.temperature}</span></div>}
									{item.respiratoryRate && <div><span>{'Resp. rate'.translate(this.props.lang)}:</span>{' '}<span style={{ fontWeight: '600' }}>{item.respiratoryRate}</span></div>}
									{item.oxygenSaturation && <div><span>{'O2 sat.'.translate(this.props.lang)}:</span>{' '}<span style={{ fontWeight: '600' }}>{item.oxygenSaturation}</span></div>}
								</div>
							),
							cardiovasular: (
								<div>
									{item.heartRate && <div><span>{'HR.'.translate(this.props.lang)}:</span>{' '}<span style={{ fontWeight: '600' }}>{item.heartRate}</span></div>}
									{item.bloodPressureSystolic && item.bloodPressureDiastolic && <div><span>{'BP'.translate(this.props.lang)}:</span>{' '}<span style={{ fontWeight: '600' }}>{item.bloodPressureSystolic}/{item.bloodPressureDiastolic}</span></div>}
								</div>
							),
							bodyMeasurements: (
								<div>
									{item.weight && (
										<div>
											<span>{'Weight'.translate(this.props.lang)}:</span>{' '}
											<span style={{ fontWeight: '600' }}>{item.weight}</span>
										</div>
									)}

									{item.height && (
										<div>
											<span>{'Height'.translate(this.props.lang)}:</span>{' '}
											<span style={{ fontWeight: '600' }}>{item.height}</span>
										</div>
									)}

									{item.bmi && (
										<div>
											<span>{'BMI'.translate(this.props.lang)}:</span>{' '}
											<span style={{ fontWeight: '600' }}>{item.bmi}</span>
										</div>
									)}
								</div>
							),
							metabolicData: (
								<div>
									{item.bloodGlucose && (
										<div>
											<span>{'Glucose'.translate(this.props.lang)}:</span>{' '}
											<span style={{ fontWeight: 600 }}>{item.bloodGlucose}</span>
										</div>
									)}
								</div>
							),
							painAssessment: (
								<div>
									{item.painScale && (
										<div>
											<span>{'Pain'.translate(this.props.lang)}:</span>{' '}
											<span style={{ fontWeight: 600 }}>{item.painScale}/10</span>
										</div>
									)}
								</div>
							),


						};
					})}


					actions={this.props.isConsentGrantedAndActive && this.state.isConsentActive ? [] : [
						{
							renderComponent: (item) =>
								item?.isDeleted ? (
									<div className="deleted-badge">
										{'Deleted'.translate(this.props.lang)}
									</div>
								) : null,
							onClick: (item) => { },
						},
						// {
						// 	component: (
						// 		<div className='tabel-action-tooltip'>
						// 			{' '}
						// 			<Isvg src={infoIcon} />{' '}
						// 			<div className='chat-icons-tooltip'>
						// 				{'Notes'.translate(this.props.lang)}
						// 			</div>{' '}
						// 		</div>
						// 	),
						// 	onClick: (item) => {
						// 		this.setState({ preview: item });
						// 	},
						// },
						{
							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={editIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Edit'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ form: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_vital_logs;
								// const hasPermission = this.props.uData.journalCuroflow[this.props.selectedGroup]?.permissions?.writePatientVitalLogs;
								return hasPermission && item && !item.isDeleted;
							}
						},
						{
							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={deleteIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Delete'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ deleteVitalLog: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_vital_logs;
								// const hasPermission = this.props.uData.journalCuroflow[this.props.selectedGroup]?.permissions?.writePatientVitalLogs;
								return hasPermission && item && !item.isDeleted;
							}
						},
					]}
					rawItems={this.state.items}
					params={params}
					sortField={params.sortField}
					sortType={params.sortType}
					updateSort={this.updateSort}
					updateParams={this.updateParams}
					updateMultipleParams={this.updateMultipleParams}
				></ListBuilder>

				{/* Preview */}
				<PreviewModal
					lang={this.props.lang}
					isOpen={this.state.preview}
					toggle={() => this.setState({ preview: false })}
					title={'Notes'.translate(this.props.lang)}
				>
					{this.state.preview?.notes || "-"}
				</PreviewModal>

				{/* Delete */}
				<DeleteModal
					lang={this.props.lang}
					isOpen={this.state.deleteVitalLog}
					toggle={() => this.setState({ deleteVitalLog: null })}
					handler={() => {
						this.delete(this.state.deleteVitalLog);
						this.state.deleteVitalLog = null;
					}}
				>
					{'Delete this vital log'.translate(this.props.lang)}?
				</DeleteModal>

				{/* Error */}
				<ErrorModal
					lang={this.props.lang}
					isOpen={this.state.error}
					toggle={() => this.setState({ error: null })}
				>
					{this.state.error}
				</ErrorModal>

				{/*  Insert / Update */}
				{this.state.form ? (
					<FormBuilder
						selectedGroup={this.props.selectedGroup}
						selectedClinic={this.props.selectedClinic}
						lang={this.props.lang}
						onSubmit={(data) => {
							this.insertOrUpdate(data);
						}}
						initialValues={this.state.form}
						size='xl'
						isOpen={this.state.form}
						toggle={() =>
							this.setState({ form: null, doctorPermissions: false })
						}
						title={
							this.state.form._id
								? 'Edit vital log'.translate(this.props.lang)
								: 'Add new vital log'.translate(this.props.lang)
						}
						buttonText={'Save'
							.translate(this.props.lang)}
						disabledCreatedInfo={true}
						fields={[
							{
								type: 'row',
								children: [
									{
										type: 'col',
										width: {
											lg: 12,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'numeric-text',
																name: 'temperature',
																label: 'Temperature'.translate(this.props.lang),
																validate: between(
																	30,
																	45,
																	'Body temperature must be between 30 and 45'.translate(
																		this.props.lang
																	)
																),
															}
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'heartRate',
																label: 'Heart rate'.translate(this.props.lang),
																validate: between(
																	30,
																	220,
																	'Heart rate in beats per minute must be between 30 and 220'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'bloodPressureSystolic',
																label: 'Blood pressure systolic'.translate(
																	this.props.lang
																),
																validate: between(
																	50,
																	250,
																	'Systolic blood pressure in mmHg must be between 50 and 250'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'bloodPressureDiastolic',
																label: 'Blood pressure diastolic'.translate(
																	this.props.lang
																),
																validate: between(
																	30,
																	150,
																	'Dialostic blood pressure in mmHg must be between 30 and 150'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'respiratoryRate',
																label: 'Respiratory rate'.translate(
																	this.props.lang
																),
																validate: between(
																	5,
																	60,
																	'Respiratory rate in breaths per minute must be between 5 and 60'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'oxygenSaturation',
																label: 'Oxygen saturation'.translate(
																	this.props.lang
																),
																validate: between(
																	0,
																	100,
																	'Oxygen stauration percentage must be between 0 and 100'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
												],
											},
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'numeric-text',
																name: 'bloodGlucose',
																label: 'Blood glucose'.translate(
																	this.props.lang
																),
																validate: between(
																	1,
																	55,
																	'Blood glucose level in mmol/L must be between 1 and 55'.translate(
																		this.props.lang
																	)
																),
															}
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'weight',
																label: 'Weight'.translate(this.props.lang),
																validate: between(
																	0,
																	500,
																	'Body weight in kilograms must be between 0 and 500'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'height',
																label: 'Height'.translate(this.props.lang),
																validate: between(
																	20,
																	300,
																	'Body height in centimeters must be between 20 and 300'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'bmi',
																label: 'Bmi'.translate(this.props.lang),
																disabled: true,
																validate: between(
																	0,
																	100,
																	'Body Mass Index(BMI) must be between 0 and 100'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 4,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'painScale',
																label: 'Pain scale'.translate(this.props.lang),
																validate: between(
																	0,
																	10,
																	'Pain scale rating must be between 0 (no pain) and 10 (worst possible pain)'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
												],
											},
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'textarea',
																name: 'notes',
																height: 100,
																label: 'Notes'.translate(this.props.lang),
															},
														],
													},
												],
											},
										],
									},
								],
							},
						]}
					></FormBuilder>
				) : null}
			</>
		);
	}

}

const selector = formValueSelector('modalForm');

export default connect(
	state => ({
		weight: selector(state, 'weight'),
		height: selector(state, 'height'),
	}),
	{
		changeField: (field, value) => change('modalForm', field, value),
	}
)(VitalLogsTab);

